import { render, staticRenderFns } from "./projectQS.vue?vue&type=template&id=a68a1732"
import script from "./projectQS.vue?vue&type=script&lang=js"
export * from "./projectQS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports